import { render, staticRenderFns } from "./odd.vue?vue&type=template&id=529770fe&scoped=true"
import script from "./odd.vue?vue&type=script&lang=js"
export * from "./odd.vue?vue&type=script&lang=js"
import style0 from "./odd.vue?vue&type=style&index=0&id=529770fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529770fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('529770fe')) {
      api.createRecord('529770fe', component.options)
    } else {
      api.reload('529770fe', component.options)
    }
    module.hot.accept("./odd.vue?vue&type=template&id=529770fe&scoped=true", function () {
      api.rerender('529770fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Report/MR/odd.vue"
export default component.exports